<template>
  <div class="floating-actions">
    <!-- 外接客服系统按钮（竖排文字醒目款） -->
    <a 
      :href="customerServiceUrl" 
      class="action-btn customer-service-btn" 
      aria-label="在线客服"
    >
      <span class="vertical-text">在线客服</span>
      <div class="icon-wrapper">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
        </svg>
      </div>
    </a>

    <!-- 返回顶部按钮 -->
    <transition name="fade-scale">
      <button
        v-show="isVisible"
        class="action-btn scroll-to-top"
        @click="scrollToTop"
        aria-label="返回顶部"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="18 15 12 9 6 15"></polyline>
        </svg>
      </button>
    </transition>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const customerServiceUrl = 'https://log.ztctjr.com/chat/index?channelId=cc7238b3e88744828339a302b2b34c3e'
const isVisible = ref(false)

const handleScroll = () => {
  isVisible.value = window.scrollY > window.innerHeight * 0.5
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
.floating-actions {
  position: fixed;
  bottom: 18%;
  right: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.85rem;
  z-index: 999;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  color: #ffffff;
  border: none;
  text-decoration: none;
  outline: none;
}

/* 竖排客服按钮 */
.customer-service-btn {
  flex-direction: column;
  width: 3.25rem;
  padding: 0.85rem 0 0.65rem;
  border-radius: 1.625rem;
  background: linear-gradient(180deg, #d4b87c 0%, #c9a96e 100%);
  box-shadow: 0 0.38rem 1.25rem rgba(201, 169, 110, 0.5);
  animation: pulse-glow 2.2s infinite;
}

/* 竖排文字规范 */
.vertical-text {
  writing-mode: vertical-lr;
  letter-spacing: 0.18em;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  user-select: none;
}

.customer-service-btn .icon-wrapper {
  width: 2.1rem;
  height: 2.1rem;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.customer-service-btn:hover {
  transform: translateY(-0.25rem) scale(1.05);
  box-shadow: 0 0.6rem 1.8rem rgba(201, 169, 110, 0.75);
}

/* 醒目的外发光呼吸灯动画 */
@keyframes pulse-glow {
  0% {
    box-shadow: 0 0.25rem 1rem rgba(201, 169, 110, 0.4);
  }
  50% {
    box-shadow: 0 0.38rem 1.5rem rgba(201, 169, 110, 0.8), 0 0 0 8px rgba(201, 169, 110, 0.2);
  }
  100% {
    box-shadow: 0 0.25rem 1rem rgba(201, 169, 110, 0.4);
  }
}

/* 返回顶部按钮 */
.scroll-to-top {
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 50%;
  background: #4779B5;
  box-shadow: 0 0.25rem 1rem rgba(71, 121, 181, 0.35);
}

.scroll-to-top:hover {
  transform: translateY(-0.25rem) scale(1.05);
  box-shadow: 0 0.38rem 1.88rem rgba(71, 121, 181, 0.6);
}

.action-btn:active {
  transform: translateY(-0.1rem) scale(0.98);
}

.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.fade-scale-enter-from,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.5) translateY(1.25rem);
}

@media (max-width: 48rem) {
  .floating-actions {
    bottom: 2.5rem;
    right: 1rem;
    gap: 0.65rem;
  }

  .customer-service-btn {
    width: 2.85rem;
    padding: 0.75rem 0 0.55rem;
  }

  .vertical-text {
    font-size: 0.9rem;
    letter-spacing: 0.12em;
  }

  .customer-service-btn .icon-wrapper {
    width: 1.85rem;
    height: 1.85rem;
  }

  .scroll-to-top {
    width: 2.85rem;
    height: 2.85rem;
  }
}
</style>